import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "full",
  "title": "ODD 4 indicateurs",
  "lead": "Assurer l’accès de tous à une éducation de qualité, sur un pied d’égalité, et promouvoir les possibilités d’apprentissage tout au long de la vie"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {IndicatorRow, IndicatorSection, IndicatorTable, TargetFourLogo, ThemeLabel, Title} = _components;
  if (!IndicatorRow) _missingMdxReference("IndicatorRow", true);
  if (!IndicatorSection) _missingMdxReference("IndicatorSection", true);
  if (!IndicatorTable) _missingMdxReference("IndicatorTable", true);
  if (!TargetFourLogo) _missingMdxReference("TargetFourLogo", true);
  if (!ThemeLabel) _missingMdxReference("ThemeLabel", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(TargetFourLogo, {}), "\n", _jsx(Title, {
      children: "Indicateurs de l’ODD 4"
    }), "\n", _jsx(_components.p, {
      children: "Assurer l’accès de tous à une éducation de qualité, sur un pied d’égalité, et promouvoir les possibilités d’apprentissage tout au long de la vie"
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-41",
        children: "Cible 4.1"
      }), _jsxs(_components.p, {
        children: ["D’ici 2030, s’assurer que toutes les filles et garçons ont bien terminé un enseignement primaire et secondaire équitable gratuit et de qualité conduisant à des résultats d’apprentissage pertinents et efficaces. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=236",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.1.0",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.0",
          children: _jsx(_components.p, {
            children: "Proportion d'enfants / jeunes préparés pour l'avenir, par sexe"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Pourcentage d’enfants et de jeunes : (a) en 2e ou 3e année d’études ; (b) en fin de cycle primaire ; et (c) en fin de premier cycle du secondaire qui maîtrisent au moins les normes d’aptitudes minimales en (i) lecture et (ii) mathématiques, par sexe"
          }), _jsx(ThemeLabel, {
            theme: "apprentissage",
            id: "4.1.1a"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.2",
          global: true,
          children: _jsx(_components.p, {
            children: "Taux d’achèvement (primaire, premier cycle du secondaire et second cycle du secondaire)"
          })
        }), _jsx(IndicatorRow, {
          id: "4.1.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.3",
          children: _jsx(_components.p, {
            children: "Taux brut d’admission en dernière année du niveau (primaire, premier cycle du secondaire)"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.4",
          children: [_jsx(_components.p, {
            children: "Taux d’enfants non scolarisés (cycle primaire, premier cycle du secondaire et second cycle du secondaire)"
          }), _jsx(ThemeLabel, {
            theme: "l'accès",
            id: "4.1.4"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.5",
          children: [_jsx(_components.p, {
            children: "Pourcentage d’enfants plus âgés que l'âge correspondant à leur année d'études (enseignement primaire, 1er cycle de l'enseignement du secondaire)"
          }), _jsx(ThemeLabel, {
            theme: "l'accès",
            id: "4.1.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.6",
          children: [_jsx(_components.p, {
            children: "Administration d’une évaluation de l’apprentissage représentative au plan national (a) en 2e ou 3e année d’études ; (b) en fin de cycle primaire ; et (c) en fin de premier cycle du secondaire"
          }), _jsx(ThemeLabel, {
            theme: "l'accès",
            id: "4.1.6"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.7",
          children: _jsx(_components.p, {
            children: "Nombre d’années d’enseignement primaire et secondaire (i) gratuit et (ii) obligatoire garanti par le cadre juridique"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-42",
        children: "Cible 4.2"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, faire en sorte que toutes les filles et tous les garçons aient accès à des activités de développement et de soins de la petite enfance et à une éducation préscolaire de qualité qui les préparent à suivre un enseignement primaire. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=253",
          children: "Voir le dernier chapitre du Rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.2.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Proportion d’enfants âgés de 24 à 59 mois dont le développement est en bonne voie en matière de santé, d’apprentissage et de bien-être psychosocial, par sexe"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.2.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.2",
          global: true,
          children: [_jsx(_components.p, {
            children: "Taux de participation à des activités organisées d’apprentissage (un an avant l’âge officiel de scolarisation dans le primaire), par sexe"
          }), _jsx(ThemeLabel, {
            theme: "l'accès",
            id: "4.2.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.2.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.3",
          children: _jsx(_components.p, {
            children: "Pourcentage d'enfants de moins de 5 ans vivant dans des environnements d'apprentissage familiaux positifs et stimulants"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.4",
          children: _jsx(_components.p, {
            children: "Taux net de scolarisation dans l'éducation de la petite enfance (a) au préprimaire et (b) dans le développement éducatif de la petite enfance"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.5",
          children: _jsx(_components.p, {
            children: "Nombre d’années d’enseignement préprimaire (a) gratuit et (b) obligatoire garanti par le cadre juridique"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-43",
        children: "Cible 4.3"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, faire en sorte que les femmes et les hommes aient tous accès dans des conditions d’égalité à un enseignement technique, professionnel ou tertiaire, y compris universitaire, de qualité et d’un coût abordable. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=263",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.3.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Taux de participation des jeunes et des adultes à un programme d’éducation et de formation scolaire ou non scolaire au cours des 12 mois précédents, par sexe"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.2",
          children: _jsx(_components.p, {
            children: "Taux brut de scolarisation dans l’enseignement supérieur"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.3",
          children: _jsx(_components.p, {
            children: "Taux de participation aux programmes d’enseignement technique et professionnel (15-24 ans), par sexe"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-44",
        children: "Cible 4.4"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, augmenter considérablement le nombre de jeunes et d’adultes disposant des compétences, notamment techniques et professionnelles, nécessaires à l’emploi, à l’obtention d’un travail décent et à l’entrepreneuriat. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=271",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.4.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4",
          global: true,
          children: _jsx(_components.p, {
            children: "Proportion de jeunes et d’adultes ayant des compétences dans le domaine des technologies de l’information et des communications, par type de compétence"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.2",
          children: _jsx(_components.p, {
            children: "Pourcentage de jeunes/adultes ayant atteint au moins un niveau minimum de compétence en littéracie numérique"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.3",
          children: _jsx(_components.p, {
            children: "Taux du niveau d’éducation atteint des jeunes/adultes par groupe d’âge et niveau d’enseignement"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-45",
        children: "Cible 4.5"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, éliminer les inégalités entre les sexes dans le domaine de l’éducation et assurer l’égalité d’accès des personnes vulnérables, y compris les personnes handicapées, les autochtones et les enfants en situation vulnérable, à tous les niveaux d’enseignement et de formation professionnelle. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=281",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.5.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5",
          global: true,
          children: [_jsx(_components.p, {
            children: "Indices de parité (femmes/hommes, urbain/rural, quintile inférieur/supérieur de richesse et autres paramètres tels que le handicap, le statut d’autochtone et les situations de conflit, à mesure que les données deviennent disponibles) pour tous les indicateurs dans le domaine de l’éducation de cette liste pouvant être ventilés"
          }), _jsx(ThemeLabel, {
            theme: "l'équité",
            id: "4.5.1"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.2",
          children: _jsx(_components.p, {
            children: "Pourcentage d'élèves a) au cours des premières années, b) en fin de cycle primaire, et c) en fin de premier cycle du secondaire qui ont leur première langue ou leur langue maternelle comme langue d'enseignement"
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.3",
          children: _jsx(_components.p, {
            children: "Existence de mécanismes de financement pour réaffecter les ressources éducatives aux populations défavorisées"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.5.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.4",
          children: [_jsx(_components.p, {
            children: "Dépenses d’éducation par élève, par niveau d’enseignement et source de financement"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.4"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.5.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.5",
          children: [_jsx(_components.p, {
            children: "Pourcentage de l’aide totale à l’éducation alloué aux pays à faible revenu"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.5"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.6",
          children: _jsx(_components.p, {
            children: "Dépenses d’éducation par source de financement (public, privé, international) en pourcentage du PIB"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-46",
        children: "Cible 4.6"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, veiller à ce que tous les jeunes et une proportion considérable d’adultes, hommes et femmes, sachent lire, écrire et compter. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=292",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.6.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion de la population d’un groupe d’âge donné ayant les compétences voulues à au moins un niveau d’aptitude fixé a) en alphabétisme et b) arithmétique fonctionnels, par sexe"
          }), _jsx(ThemeLabel, {
            theme: "apprentissage",
            id: "4.6.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.6.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.2",
          children: [_jsx(_components.p, {
            children: "Taux d’alphabétisme des jeunes/adultes"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.2"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-47",
        children: "Cible 4.7"
      }), _jsxs(_components.p, {
        children: ["DD’ici à 2030, faire en sorte que tous les élèves acquièrent les connaissances et compétences nécessaires pour promouvoir le développement durable, notamment par l’éducation en faveur du développement et de modes de vie durables, des droits de l’homme, de l’égalité des sexes, de la promotion d’une culture de paix et de non-violence, de la citoyenneté mondiale et de l’appréciation de la diversité culturelle et de la contribution de la culture au développement durable. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=300",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.7.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Degré d’intégration de i) l’éducation à la citoyenneté mondiale et ii) l’éducation au développement durable dans a) les politiques nationales d’éducation, b) les programmes d’enseignement, c) la formation des enseignants et d) l’évaluation des étudiants"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.2",
          children: _jsx(_components.p, {
            children: "Pourcentage d’écoles qui dispensent une éducation au VIH et à la sexualité basée sur les compétences utiles dans la vie"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.3",
          children: _jsx(_components.p, {
            children: "Degré d’intégration des intentions de la politique verte  dans les documents du programme"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.4",
          children: _jsx(_components.p, {
            children: "Pourcentage d’élèves du premier cycle du secondaire montrant une compréhension adéquate des questions liées à la citoyenneté mondiale et à la durabilité"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.5",
          children: _jsx(_components.p, {
            children: "Pourcentage d’élèves du premier cycle du secondaire démontrant des compétences en sciences de l’environnement et les géosciences"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-4a",
        children: "Cible 4.a"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, faire construire des établissements scolaires qui soient adaptés aux enfants, aux personnes handicapées et aux deux sexes ou adapter les établissements existants à cette fin et fournir un cadre d’apprentissage effectif qui soit sûr, exempt de violence et accessible à tous. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=308",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.a.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion d’établissements scolaires offrant des services essentiels, par type de service"
          }), _jsx(ThemeLabel, {
            theme: "qualité",
            id: "4.a.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.a.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.2",
          children: [_jsx(_components.p, {
            children: "Pourcentage d’élèves victimes d’harcèlement scolaire au cours des 12 derniers mois au a) cycle primaire et b) premier cycle du secondaire"
          }), _jsx(ThemeLabel, {
            theme: "qualité",
            id: "4.a.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.a.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.3",
          children: _jsx(_components.p, {
            children: "Nombre d’attaques contre les élèves, le personnel et les établissements"
          })
        }), _jsx(IndicatorRow, {
          id: "4.a.4",
          global: true,
          children: _jsx(_components.p, {
            children: "Proportion d'enfants scolarisés recevant des repas scolaires"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-4b",
        children: "Cible 4.b"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2020, augmenter considérablement à l’échelle mondiale le nombre de bourses d’études offertes aux pays en développement, en particulier aux pays les moins avancés, aux petits États insulaires en développement et aux pays d’Afrique, pour financer le suivi d’études supérieures, y compris la formation professionnelle, les cursus informatiques, techniques et scientifiques et les études d’ingénieur, dans des pays développés et d’autres pays en développement. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=321",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsx(IndicatorTable, {
        children: _jsx(IndicatorRow, {
          id: "4.b.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.b/i4.b.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Volume de l’aide publique au développement consacrée aux bourses d’études, par secteur et type de formation"
          })
        })
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "cible-4c",
        children: "Cible 4.c"
      }), _jsxs(_components.p, {
        children: ["D’ici à 2030, accroître considérablement le nombre d’enseignants qualifiés, notamment au moyen de la coopération internationale pour la formation d’enseignants dans les pays en développement, surtout dans les pays les moins avancés et les petits États insulaires en développement. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=331",
          children: "Voir le dernier chapitre du rapport GEM"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.c.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion d’enseignants possédant les qualifications minimales requises par niveau d’études"
          }), _jsx(ThemeLabel, {
            theme: "qualité",
            id: "4.c.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.c.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.1",
          children: [_jsx(_components.p, {
            children: "Ratio élèves-enseignant formé par niveau d'enseignement"
          }), _jsx(ThemeLabel, {
            theme: "qualité",
            id: "4.c.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.c.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.3",
          children: _jsx(_components.p, {
            children: "Pourcentage d'enseignants qualifiés selon les normes nationales, par niveau d'enseignement et type d'établissement"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.4",
          children: _jsx(_components.p, {
            children: "Ratio élèves-enseignant qualifié par niveau d'enseignement"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.5",
          children: _jsx(_components.p, {
            children: "Salaire moyen des enseignants par rapport aux autres professions nécessitant un niveau de qualification comparable"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.6",
          children: _jsx(_components.p, {
            children: "Taux d'attrition des enseignants par niveau d'éducation"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.7",
          children: _jsx(_components.p, {
            children: "Pourcentage d'enseignants ayant reçu une formation continue au cours des 12 derniers mois par type de formation"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "finance",
        children: "Finance"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000385723/PDF/385723eng.pdf.multi.page=340",
          children: "Voir le dernier chapitre du rapport GEM"
        })
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "F.1",
          children: [_jsx(_components.p, {
            children: "Dépenses publiques pour l’éducation en pourcentage du PIB"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "F.2",
          children: [_jsx(_components.p, {
            children: "Dépenses publiques pour l’éducation en pourcentage des dépenses totales du gouvernement"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.2"
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
